import { cn } from "@gigpro/ui/tailwind/cn";
import type React from "react";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  badgeContent?: React.ReactNode;
  badgeClassName?: string;
  max?: number;
  invisible?: boolean;
}

export function Badge({
  className,
  children,
  badgeContent,
  badgeClassName,
  max,
  invisible,
  ...rest
}: Readonly<BadgeProps>) {
  const finalBadgeContent = max && typeof badgeContent === "number" && badgeContent > max ? `${max}+` : badgeContent;
  return (
    <div className={cn("relative flex items-center justify-center", className)} {...rest}>
      {children}
      <span
        className={cn(
          "absolute top-0 right-0 flex h-4 min-w-4 translate-x-[50%] translate-y-[-50%] transform items-center justify-center rounded-full bg-error px-1 text-small font-semibold text-white transition-opacity duration-200",
          (invisible || !badgeContent) && "opacity-0",
          badgeClassName,
        )}
        aria-hidden={invisible || !badgeContent}
      >
        {finalBadgeContent}
      </span>
    </div>
  );
}
